export enum LANDFilters {
  ONLY_FOR_RENT,
  ONLY_FOR_SALE,
  ALL_LAND
}
